export const statusHelper = [
    { key: "invited", value: "Invitation Sent", color: "primary", icon: "fa fa-envelope" },
    { key: "rejected", value: "Invitation Rejected", color: "danger", icon: "fa fa-times" },
    { key: "clone_failed", value: "Clone Failed", color: "danger", icon: "fa fa-exclamation-triangle" },
    { key: "accepted", value: "App Created", color: "success", icon: "fa fa-check" },
    { key: "disabled", value: "App Disabled", color: "warning", icon: "fa fa-ban" },
    { key: "deleted", value: "App Deleted", color: "danger", icon: "fa fa-trash" },
    { key: "notfound", value: "Unknow", color: "info", icon: "fa fa-question" },
]